module.exports = __webpack_public_path__ + "static/svh-9d7fc9d3999e51d8557d279ed8e0abca.mp4";